import React, { createRef } from 'react';
import { motion } from 'framer-motion';

class FadeIn extends React.Component {
  constructor(props) {
    super(props);
    this.ref = createRef();
    this.state = {
      isVisible: false,
    };
  }

  componentDidMount() {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.setState({ isVisible: true });
          observer.unobserve(this.ref.current);
        }
      },
      { threshold: 0.8,
        rootMargin: '0px 0px -100px 0px', 
       }
    );

    if (this.ref.current) {
      observer.observe(this.ref.current);
    }
  }

  render() {
    const { isVisible } = this.state;

    return (
    
       
      <motion.div
        ref={this.ref}
        initial={{ opacity: 0 }}
  animate={{ opacity: 1 }}
      transition={{ duration: 2, delay: 0.5 }}

      >
        {this.props.children}
      </motion.div>
      
    );
  }
}

export default FadeIn;
